import { render, staticRenderFns } from "./dialog-motive-pay4Fun.vue?vue&type=template&id=af07f84c"
import script from "./dialog-motive-pay4Fun.vue?vue&type=script&lang=js"
export * from "./dialog-motive-pay4Fun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports